import { render } from "./AddRole.vue?vue&type=template&id=0906329c&scoped=true&ts=true"
import script from "./AddRole.vue?vue&type=script&lang=ts"
export * from "./AddRole.vue?vue&type=script&lang=ts"

import "./AddRole.vue?vue&type=style&index=0&id=0906329c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0906329c"]])

export default __exports__